import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { LoginPage } from "./pages/LoginPage";
import { Home } from "./pages/Home";
import { GestaoSubHome } from "./pages/GestaoSubHome";
import { ModulePlaceholder } from "./pages/ModulePlaceholder";

// PAC MAN Pages
import { PacManSubHome } from "./pages/pacman/PacManSubHome";
import { CadastroProdutos } from "./pages/pacman/CadastroProdutos";
import { Movimentacoes } from "./pages/pacman/Movimentacoes";
import { EstoqueAtual } from "./pages/pacman/EstoqueAtual";
import { Compras } from "./pages/pacman/Compras";

// Clientes Pages
import { ClientesList } from "./pages/clientes/ClientesList";
import { ClienteFicha } from "./pages/clientes/ClienteFicha";
import { ClientesImportar } from "./pages/clientes/ClientesImportar";

// COD Pages
import { CodAgenda } from "./pages/cod/CodAgenda";

// Caixa Pages
import { CaixaDia } from "./pages/caixa/CaixaDia";

// AFO Pages
import { AfoPage } from "./pages/afo/AfoPage";

// Comandas Pages
import { ComandasPage } from "./pages/comandas/ComandasPage";

// Servicos Pages
import { ServicosPage } from "./pages/servicos/ServicosPage";

// Tarefas Pages
import { TarefasPage } from "./pages/tarefas/TarefasPage";

// Historico Pages (ADMIN only)
import { HistoricoPage } from "./pages/historico/HistoricoPage";

// Producao Pages (ADMIN only)
import { ProducaoPage } from "./pages/producao/ProducaoPage";

const AppRoutes = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#F7F6F4] flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-[#1B4332] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) return <LoginPage />;

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/gestao" element={<GestaoSubHome />} />
      <Route path="/gestao/pacman" element={<PacManSubHome />} />
      <Route path="/gestao/pacman/cadastro" element={<CadastroProdutos />} />
      <Route path="/gestao/pacman/movimentacoes" element={<Movimentacoes />} />
      <Route path="/gestao/pacman/estoque" element={<EstoqueAtual />} />
      <Route path="/gestao/pacman/compras" element={<Compras />} />
      <Route path="/gestao/clientes" element={<ClientesList />} />
      <Route path="/gestao/clientes/importar" element={<ClientesImportar />} />
      <Route path="/gestao/clientes/:clienteId" element={<ClienteFicha />} />
      <Route path="/gestao/cod" element={<CodAgenda />} />
      <Route path="/gestao/caixa" element={<CaixaDia />} />
          <Route path="/gestao/afo" element={<AfoPage />} />
          <Route path="/gestao/comandas" element={<ComandasPage />} />
          <Route path="/gestao/servicos" element={<ServicosPage />} />
          <Route path="/gestao/tarefas" element={<TarefasPage />} />
          <Route path="/gestao/historico" element={<HistoricoPage />} />
          <Route path="/gestao/producao" element={<ProducaoPage />} />
          <Route path="/gestao/:moduleId" element={<ModulePlaceholder />} />
      <Route path="/:moduleId" element={<ModulePlaceholder />} />
    </Routes>
  );
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
